import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './styles.module.scss';
import {
  get_now,
  get_token,
  get_user_info,
  set_token
} from '../../../helpers/api';
import { routes } from '../../../assets/routes';
import Loader from '../../common/Loader';
import Logo from '../../../assets/icons/logo.png';
import { toast } from 'react-toastify';
import { useMutation } from '@tanstack/react-query';
import { loginRequest } from './api';
import { TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { useTranslation } from '../../../i18n/LanguageProvider';

const Login = () => {
  const { t } = useTranslation();
  const [userInfo, setUserInfo] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    if (get_token() && get_user_info().exp > get_now()) {
      history.push(routes.HOME);
    } else {
      setLoading(false);
    }
  }, []);
  const loginMutation = useMutation(loginRequest, {
    onSuccess({ data: { access_token, is_new_user } }) {
      set_token(access_token);
      if (is_new_user) {
        history.push(routes.WELCOME);
      } else {
        history.push(routes.HOME);
      }
      toast.success(t('auth.loginSuccess'));
    },
    onError(err) {
      toast.error(err.response?.data?.detail);
    }
  });

  return loading ? (
    <Loader size={60} />
  ) : (
    <div className={styles.page} style={{ maxWidth: '100%' }}>
      <form
        className={styles.container}
        onSubmit={(e) => {
          e.preventDefault();
          loginMutation.mutate({
            username: userInfo.username,
            password: userInfo.password
          });
        }}
      >
        <img src={Logo} alt="logo" className={styles.logo} />
        <TextField
          className={styles.input}
          value={userInfo.username}
          onChange={(e) =>
            setUserInfo({ ...userInfo, username: e.target.value })
          }
          label={t('auth.username')}
          id="username"
          ltr
        />
        <TextField
          className={styles.input}
          value={userInfo.password}
          onChange={(e) =>
            setUserInfo({ ...userInfo, password: e.target.value })
          }
          label={t('auth.password')}
          id="password"
          ltr
          type="password"
        />
        <Button
          fullWidth
          variant="contained"
          type="submit"
          loading={loginMutation.isLoading}
          className={styles.btn}
          disabled={loginMutation.isLoading}
        >
          {t('auth.login')}
        </Button>

        <Button
          variant="text"
          loading={loginMutation.isLoading}
          disabled={loginMutation.isLoading}
          onClick={() => history.push(routes.RESETPASSWORD)}
          size="small"
          className={styles.forgotPassBtn}
        >
          {t('auth.forgotPassword')}
        </Button>
      </form>
    </div>
  );
};

export default Login;
